module.exports = __webpack_public_path__ + "img/lt_project.17a1693b.png";